module.exports = __webpack_public_path__ + "static/media/30.2729b26b.jpg";